import { useMemo } from 'react';
import { Text } from "../../components/texts/text";
import Title from "../../components/texts/title";
import { _colorText, _sizeHeading, _sizeText } from "../../core/core";
import { useOrder } from '../../entities/order/context/OrderContext';
import "./howwork.css";


export const Howwork = () => {
    const { service } = useOrder();
    const steps = useMemo(() => {
        return service?.how.map((step, idx) => ({
            number: `${idx + 1}.`,
            title: step.title,
            desc: step.description
        }))
    }, [service])
    return (
        <div className="howwork-new">
            <div className="howwork-title">

                <Title type={_sizeHeading.h2_2}>
                    Как всё устроено?
                </Title>
            </div>
            <div className="howwork-block">
                {steps?.map((step, idx) => (
                    <div className="howwork-card" key={idx}>
                        <Text size={_sizeText.mbold} color={_colorText.black}>{step.number}</Text>
                        <div className="howwork-card-body">
                            <Text size={_sizeText.mbold} >{step.title}</Text>
                            <Text size={_sizeText.m} >{step.desc}</Text>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};